module.exports = {"sorry":"Hier ist leider etwas schiefgegangen.","tryagain":"Versuchen, neu zu laden"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/de-DE/strings.json
// module id = 1175
// module chunks = 0